import { TInitialState } from '@r1-frontend/service-engineer-visit/reducer/initialState';

const getLoadingState = (state: TInitialState) => state._loading;

export default getLoadingState;
